/**
 * Tool Header Component
 *
 * Displays the tool icon, name, and optional duration in a consistent header layout.
 *
 * Phase 6: icon and displayName are optional — they come from the
 * backend AgentToolCatalogService and can be undefined during the brief
 * window before the catalog loads, or if it's unreachable. Callers
 * supply their own fallbacks (Sparkles + humanized id) so the header
 * always has something to render.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loader2, Sparkles } from 'lucide-react';
import { formatDuration } from '../../lib/tool-configs';
export function ToolHeader({ icon, displayName, isRunning = false, loadingText, duration }) {
    const Icon = icon ?? Sparkles;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center justify-between gap-2",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2 text-xs",
                children: [
                    isRunning ? /*#__PURE__*/ _jsx(Loader2, {
                        className: "h-3.5 w-3.5 animate-spin"
                    }) : /*#__PURE__*/ _jsx(Icon, {
                        className: "h-3.5 w-3.5"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium",
                        children: displayName ?? 'Tool'
                    }),
                    isRunning && loadingText && /*#__PURE__*/ _jsxs("span", {
                        className: "opacity-70",
                        children: [
                            "· ",
                            loadingText
                        ]
                    })
                ]
            }),
            duration !== undefined && !isRunning && /*#__PURE__*/ _jsx("span", {
                className: "text-xs",
                children: formatDuration(duration)
            })
        ]
    });
}
